import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
    parsePaging,
    parseSorting,
} from '../../utils/queryString';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import Spinner from '../Spinner';
import Paginator from '../Paginator';
import Error from '../errors/Error';
import CashLimitUploadEventsList from './CashLimitUploadEventsList';
import { ALL_CASH_LIMIT_UPLOAD_EVENTS } from '../../graphql/cashLimitUploadEvents';
import Constants from '../../utils/Constants';
import { getValueMapping } from './CashLimitUploadEventRow';

function CashLimitUploadEvents() {
    const location = useLocation();
    const { t } = useTranslation();
    const { page, perPage } = parsePaging(location.search);
    const {
        sortKey = 'uploadTimestamp',
        sortDirection = Constants.SORT_DESC,
    } = parseSorting(location.search);
    const [refetchProps, setRefetchProps] = useState({
        perPage,
        page,
        sortKey,
        sortDirection,
    });
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(ALL_CASH_LIMIT_UPLOAD_EVENTS, {
        variables: refetchProps,
        valueMappingFn: getValueMapping,
    });
    const onPageChange = (newPage) => setRefetchProps({
        ...refetchProps,
        page: newPage,
    });
    const onSort = (newSorting) => setRefetchProps({
        ...refetchProps,
        sortKey: newSorting.key,
        sortDirection: newSorting.direction,
    });
    let result;
    if (loading) {
        result = <Spinner className="cash-limit-upload-events-loading" />;
    } else if (error) {
        result = <Error className="cash-limit-upload-events-error" error={error} />;
    } else {
        result = (
            <Paginator
                totalCount={data.allCashLimitUploadEvents.totalCount}
                perPage={perPage}
                currentPage={refetchProps.page}
                onPageChange={onPageChange}
                bottom
            >
                <CashLimitUploadEventsList
                    cashLimitUploadEvents={data.allCashLimitUploadEvents.models}
                    onSort={onSort}
                    sortingParam={{ key: refetchProps.sortKey, direction: refetchProps.sortDirection }}
                />
            </Paginator>
        );
    }
    return (
        <>
            <h4><FontAwesomeIcon icon="file-invoice-dollar" />&nbsp;{t('title.cash-limit-upload-events')}</h4>
            {result}
        </>
    );
}

export default CashLimitUploadEvents;
